import React, { useEffect } from "react";
import { Routes, Route, useRoutes, useNavigate } from "react-router-dom";


import { ScrollToTop } from "../components";
import Home from "../pages/home/Modules";

// admin
import Profile from "../pages/admin/Profile";
import ProfileSettings from "../pages/admin/ProfileSettings";

// auths pages
import AuthRegister from "../pages/auths/AuthRegister";
import AuthLogin from "../pages/auths/AuthLogin";
import AuthReset from "../pages/auths/AuthReset";
import NotFound from "../pages/error/NotFound";

// customer and supplier auths pages
import CustomerRegister from "../pages/customer/auth/CustomerRegister";
import CustomerRegisterWithReferral from "../pages/customer/auth/CustomerRegisterWithReferral";
import UserNavbar from "../pages/customer/auth/usernavbar";
import SupplierRegister from "../pages/supplier/auth/SupplierRegister";
import UserCommissionHistory from "../pages/customer/auth/UserComissionHistory";


import Cart from '../pages/customer/order/Cart';
import Checkout from '../pages/customer/order/CheckOut';
import Orders from "../pages/customer/order/Orders";





import User from "../pages/masters/user/User";
import UsersList from "../pages/masters/user/UsersList";
import UsersView from "../pages/masters/user/UsersView";
import UsersEdit from "../pages/masters/user/UsersEdit";

import { Test1 } from "../pages/test/Test1";

import ChangePassword from "../pages/masters/change-password/ChangePassword";
import HrDashboard from "../pages/dashboard/HrDashboard";
import Welcome from "../pages/dashboard/Welcome";
import Caste from "../pages/masters/caste/Caste";
import State from "../pages/masters/state/State";
import Taluk from "../pages/masters/taluk/Taluk";
import District from "../pages/masters/district/District";
// import Category from "../pages/job/category/category";
import Role from "../pages/job/role/role";
import Position from "../pages/job/position/position";
import Course_Name from "../pages/masters/education_course/education_course";
import Education_Level from "../pages/masters/education_level/education_level";
import Institutuion_Name from "../pages/masters/institution_name/institution_name";
import Recruitment_Company from "../pages/masters/recruitment_company/recruitment_company";
import Recruitment_Agency from "../pages/masters/recruitment_agency/recruitment_agency";
import Applicant from "../pages/job/applicant/applicant";
import Job_application from "../pages/job/job_application/job_application";
import Product from "../pages/admin/product/Product";
import ProductList from "../pages/admin/product/ProductList";
import ProductView from "../pages/admin/product/ProductView";
import ProductEdit from "../pages/admin/product/ProductEdit";

import ProductVariant from "../pages/admin/ProductVariant/ProductVariant";
import ProductVariantList from "../pages/admin/ProductVariant/ProductVariantList";
import ProductVariantEdit from "../pages/admin/ProductVariant/ProductVariantEdit";
import ProductVariantView from "../pages/admin/ProductVariant/ProductVariantView";
import AdminOrdersList from "../pages/admin/orders/AdminOrdersList";
import AssignVendor from "../pages/admin/customer-vendor/AssignVendor";
import AdminDashboard from "../pages/admin/Dashboard/AdminDashboard";
import AdminSKOSList from "../pages/admin/Dashboard/AdminSKOSList";
import AdminComission from "../pages/admin/Dashboard/AdminComission";
import AdminCustomer from "../pages/admin/Dashboard/AdminCustomer";

import CategoryView from "../pages/admin/category/CategoryView";
import CategoryEdit from "../pages/admin/category/CategoryEdit";
import Category from "../pages/admin/category/Category";
import CategoryList from "../pages/admin/category/CategoryList"; // No need for another Category import

import Unit from "../pages/admin/unit/Unit";
import UnitEdit from "../pages/admin/unit/UnitEdit";
import UnitView from "../pages/admin/unit/UnitView";
import UnitList from "../pages/admin/unit/UnitList";

import City from "../pages/admin/city/City";
import CityEdit from "../pages/admin/city/CityEdit";
import CityView from "../pages/admin/city/CityView";
import CityList from "../pages/admin/city/CityList";

import Brand from "../pages/admin/brand/Brand";
import BrandEdit from "../pages/admin/brand/BrandEdit";
import BrandView from "../pages/admin/brand/BrandView";
import BrandList from "../pages/admin/brand/BrandList";
import SupplierDashboard from "../pages/supplier/auth/SupplierDashboard";
import EditProfile from "../pages/customer/auth/EditProfile";
import UpdatedCustomerPassword from "../pages/admin/UpdateCustomerPassword";
import AdminPanel from "../pages/admin/Dashboard/AdminPanel";
import SupplierPanel from "../pages/supplier/auth/SupplierPanel";
import ProductListingPage from "../pages/dashboard/ProductListingPage";
import TermsAndConditions from "../pages/customer/auth/TermsAndConditions";
import ReturnAndRefundPolicy from "../pages/customer/auth/ReturnAndRefundPolicy";
import PrivacyPolicy from "../pages/customer/auth/PrivacyPolicy";
import AboutUs from "../pages/customer/auth/AboutUs";
import ComboListPage from "../pages/dashboard/ComboListPage";
import ComboDetailPage from "../pages/dashboard/ComboDetailPage";

import Register from "../pages/customer/auth/Register";
import UserRegister from "../pages/customer/auth/UserRegister";
import ProfilePage from "../pages/customer/auth/profilepage";
import CreateUserDetails from "../pages/customer/auth/UserDetails/CreateUserDetails";
import UserDetailEdit from "../pages/customer/auth/UserDetails/UserDetailEdit";
import UserDetailList from "../pages/customer/auth/UserDetails/UserDetailList";
import UserDetailView from "../pages/customer/auth/UserDetails/UserDetailView";
import App from "../pages/customer/auth/UserTree";
import AddUserAddressDetails from "../pages/customer/auth/UserAddress/addUserAddressDetails";

import UserDetailSelect from "../pages/customer/auth/UserDetails/UserDetailSelect";
import EditAddress from "../pages/customer/auth/UserAddress/EditAddress";
import UserAddressCheck from "../pages/customer/auth/UserAddress/UserAddressCheck ";
import UserProfilePage from "../pages/customer/auth/UserDetails/UserProfilePage";
import SmsOtpReset from "../pages/customer/auth/SmsOtpReset";
import ComboDetailPage2 from "../pages/dashboard/ComboDetailPage2";
import UnpinnedChildrenTree from "../pages/customer/auth/UnpinnedChildrenTree";
import AddBankDetails from "../pages/customer/auth/Bank/AddBankDetails ";
import EditBankDetails from "../pages/customer/auth/Bank/EditBankDetails ";
// import SeatSelection from "../pages/customer/order/SeatSelection";



// Admin and Reports

function Router() {
  const token = localStorage.getItem("jwtToken");
  // const isAuthenticated = token !== null && token !== "";
  const isAuthenticated = true;
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  return (
    <ScrollToTop>
      <Routes>
        <Route path="/home" element={<Welcome />} />
        <Route path="/shop" element={<HrDashboard />} />

        <Route path="/shop/combos/:categoryId" element={<ComboListPage />} />
        <Route path="/shop/combo/:comboId" element={<ComboDetailPage />} />
        <Route path="/shop/Combo/direct/:comboId" element={<ComboDetailPage2 />} />
        <Route path="/shop/home" element={<Home />} />
        <Route path="/shop/cart" element={<Cart />} />
        <Route path="/shop/orders" element={<Orders />} />
        <Route path="/shop/checkout" element={<Checkout />} />
        <Route path="/Product-List/:categoryId" element={<ProductListingPage />} />

        <Route path="/shop/auths">

          <Route path="register" element={<AuthRegister />} />
          
          <Route path="user-register" element={<UserRegister />} />
          <Route path="registration/:id" element={<Register />} />
          <Route path="UserTree" element={<App />} />
          <Route path="tree" element={<UnpinnedChildrenTree />} />
          <Route path="UserDetailSelect" element={<UserDetailSelect />} />
          <Route path="add-user-details" element={<CreateUserDetails />} />
          <Route path="update-user-details/:id" element={<UserDetailEdit />} />
          <Route path="view-user-details" element={<UserDetailView />} />
          <Route path="List-user-details" element={<UserDetailList />} />
          <Route path="add-user-address-details" element={<AddUserAddressDetails />} />
          <Route path="login" element={<AuthLogin />} />
          <Route path="reset" element={<AuthReset />} />
          <Route path="supplier-register" element={<SupplierRegister />} />
          <Route path="supplier-dashboard" element={<SupplierDashboard />} />
          <Route path="supplier-panel" element={<SupplierPanel />} />
          <Route path="customer-register" element={<CustomerRegister />} />
          <Route path="Edit-Profile" element={<EditProfile />} />
          <Route path="User-Comission" element={<UserCommissionHistory />} />
          <Route path="sms-verify" element={<SmsOtpReset />} />
          <Route path="terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="return-and-refund-policy" element={<ReturnAndRefundPolicy />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="cart" element={<Cart />} />
          <Route path="orders" element={<Orders />} />
          <Route path="checkout" element={<Checkout />} />
          {/* <Route path="/seat-selection" element={<SeatSelection />} /> */}
          <Route path="customer-register/:id" element={<CustomerRegisterWithReferral />} />
          <Route path="usernavbar" element={<UserNavbar />} />
          <Route path="user-profile" element={<ProfilePage />} />
          <Route path="user-profile-page" element={<UserProfilePage />} />
          <Route path="add-user-address" element={<AddUserAddressDetails/>} />
          <Route path="edit-address/:id" element={<EditAddress />} />

          <Route path="user-address-check" element={<UserAddressCheck />} />
          <Route path="user-bank-detail" element={<AddBankDetails />} />
          <Route path="edit-user-bank-detail/:id" element={<EditBankDetails />} />







          {/* Catch-all route for 404 errors */}
          <Route path="*" element={<NotFound />} />
        </Route>


        {isAuthenticated && (
          <Route path="shop">
            <Route path="admin">
            <Route path="admin-panel" element={<AdminPanel />} />
              <Route path="profile" element={<Profile />} />
              <Route path="profile-settings" element={<ProfileSettings />} />
              <Route path="product" element={<Product />} />
              <Route path="product-list" element={<ProductList />} />
              <Route path="product-view/:id" element={<ProductView />} />
              <Route path="product-edit/:id" element={<ProductEdit />} />
              <Route path="product-variant/:id" element={<ProductVariant />} />
              <Route path="product-variant-list" element={<ProductVariantList />} />
              <Route path="product-variant-edit/:id" element={<ProductVariantEdit />} />
              <Route path="product-variant-view/:id" element={<ProductVariantView />} />
              <Route path="admin-orders" element={<AdminOrdersList />} />
              <Route path="assign-vendor" element={<AssignVendor />} />
              <Route path="Updated-Customer-Password" element={<UpdatedCustomerPassword />} />
              <Route path="admin-dashboard" element={<AdminDashboard />} />
              <Route path="admin-skos-list" element={<AdminSKOSList />} />
              <Route path="admin-comission" element={<AdminComission />} />
              <Route path="admin-customer" element={<AdminCustomer />} />
              
    



              <Route path="category" element={<Category />} />
              <Route path="category-list" element={<CategoryList />} />
              <Route path="category-view/:id" element={<CategoryView />} />
              <Route path="category-edit/:id" element={<CategoryEdit />} />

              <Route path="unit" element={<Unit />} />
              <Route path="unit-list" element={<UnitList />} />
              <Route path="unit-view/:id" element={<UnitView />} />
              <Route path="unit-edit/:id" element={<UnitEdit />} />

              <Route path="city" element={<City />} />
              <Route path="city-list" element={<CityList />} />
              <Route path="city-view/:id" element={<CityView />} />
              <Route path="city-edit/:id" element={<CityEdit />} />

              <Route path="brand" element={<Brand />} />
              <Route path="brand-list" element={<BrandList />} />
              <Route path="brand-view/:id" element={<BrandView />} />
              <Route path="brand-edit/:id" element={<BrandEdit />} />

            </Route>



            <Route path="not-found" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
            <Route path="user" element={<User />} />
            <Route path="users-list" element={<UsersList />} />
            <Route path="users-view/:id" element={<UsersView />} />
            <Route path="users-edit/:id" element={<UsersEdit />} />

            {/* Change Password */}
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="test1" element={<Test1 />} />

            <Route path="dashboard" element={<HrDashboard />} />
           

            <Route path="masters">
              <Route path="caste" element={<Caste />} />
            </Route>

            <Route path="masters">
              <Route path="skills" element={<skills />} />
            </Route>

            <Route path="masters">
              <Route path="state" element={<State />} />
            </Route>

            <Route path="masters">
              <Route path="district" element={<District />} />
            </Route>

            <Route path="masters">
              <Route path="taluk" element={<Taluk />} />
            </Route>

            <Route path="masters">
              <Route path="city" element={<City />} />
            </Route>

            <Route path="masters">
              <Route path="course_name" element={<Course_Name />} />
            </Route>

            <Route path="masters">
              <Route path="education_level" element={<Education_Level />} />
            </Route>

            <Route path="masters">
              <Route path="institutuion_name" element={<Institutuion_Name />} />
            </Route>

            <Route path="masters">
              <Route
                path="recritment_company"
                element={<Recruitment_Company />}
              />
            </Route>

            <Route path="masters">
              <Route
                path="recruitment_agency"
                element={<Recruitment_Agency />}
              />
            </Route>

            <Route path="job">
              <Route path="category" element={<Category />} />
            </Route>

            <Route path="job">
              <Route path="role" element={<Role />} />
            </Route>

            <Route path="job">
              <Route path="position" element={<Position />} />
            </Route>

            <Route path="job">
              <Route path="applicant" element={<Applicant />} />
            </Route>

            <Route path="job">
              <Route path="job_application" element={<Job_application />} />
            </Route>
          </Route>
        )}
      </Routes>
    </ScrollToTop>
  );
}

export default Router;
